import React, { useState,useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaPlus, FaMinus } from 'react-icons/fa';
import AxiosInstance from '../AxiosInstance';
import ToastNotification from '../ToastNotification';

const ProfileModal = ({ showModal, handleClose, userData }) => {
  const [phoneError, setPhoneError] = useState("");
  const toastRef = useRef(null);
  const safeParseJson = (data) => {
    try {
      return data ? JSON.parse(data) : []; 
    } catch (e) {
      return []; 
    }
  };
  
  const safeValue = (value) => (value === "Not provided" ? "" : value);

  const [formData, setFormData] = useState(() => ({
  first_name: safeValue(userData?.first_name),
  middle_name: safeValue(userData?.middle_name),
  last_name: safeValue(userData?.last_name),
  email: safeValue(userData?.email),
  gender: safeValue(userData?.gender),
  date_of_birth: safeValue(userData?.date_of_birth),
  address: safeValue(userData?.address),
  department_name: safeValue(userData?.department_name),
  date_of_join: safeValue(userData?.date_of_join),
  about: safeValue(userData?.about),
  education: safeParseJson(userData?.education),
  social_media_links: safeParseJson(userData?.social_media_links),
  phone_number: safeValue(userData?.phone_number),
  emergency_contact: safeValue(userData?.emergency_contact),
}));


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone_number") {
      if (value === "") {
        setPhoneError(""); 
        setFormData({ ...formData, [name]: value });
        return;
      }

      if (!/^[1-9][0-9]{0,9}$/.test(value)) {
        setPhoneError("Phone number must be exactly 10 digits and cannot start with 0.");
      } else {
        setPhoneError("");
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleArrayChange = (arrayName, index, field, value) => {
    const updatedArray = [...formData[arrayName]];
    updatedArray[index][field] = value;
    setFormData({ ...formData, [arrayName]: updatedArray });
  };

  const handleAddArrayItem = (arrayName, newItem) => {
    setFormData({ ...formData, [arrayName]: [...formData[arrayName], newItem] });
  };

  const handleRemoveArrayItem = (arrayName, index) => {
    const updatedArray = formData[arrayName].filter((_, i) => i !== index);
    setFormData({ ...formData, [arrayName]: updatedArray });
  };

  const handleSaveChanges = async () => {
    const updatedUserData = {
      user_id: userData?.user_id,
      address: formData.address,
      about: formData.about,
      education: formData.education,
      social_media_links: formData.social_media_links,
      phone_number: formData.phone_number,
      emergency_contact: formData.emergency_contact,
    };

    console.log("Updated User Data:", updatedUserData);

    try {
      const response = await AxiosInstance.post("/employee/updateProfile", updatedUserData);
      console.log("Response:", response.data);

      if (response.data.message === "Profile updated successfully") {
        console.log("Profile updated successfully");
        handleClose();
        window.location.reload();
      } else {
         toastRef.current?.showToast("Failed to update profile:", "danger");
      }
    } catch (error) {
       toastRef.current?.showToast("Error during save:", "danger");
    }
  };
    
  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="row">
          <div className="col-md-6">
            <label>First Name</label>
            <input
              type="text"
              name="first_name"
              className="form-control"
              value={formData.first_name}
              readOnly
            />
          </div>
          <div className="col-md-6">
            <label>Middle Name</label>
            <input
              type="text"
              name="middle_name"
              className="form-control"
              value={formData.middle_name}
              readOnly
            />
          </div>
          <div className="col-md-6">
            <label>Last Name</label>
            <input
              type="text"
              name="last_name"
              className="form-control"
              value={formData.last_name}
              readOnly          
              />
          </div>
        </div>
         <div className="mt-3">
            <label>Department</label>
            <input
              type="text"
              name="department_name"
              className="form-control"
              value={formData.department_name}
              readOnly
            /> 
        </div>
        <div className="mt-3">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              readOnly
            />
          </div>
          <div className="mt-3">
          <label>Gender</label>
          <input
            type="text"
            name="gender"
            className="form-control"
            value={formData.gender}
            readOnly
          />
        </div>
        <div className="mt-3">
        <label>Date of Birth</label>
        <input
          type="date"
          name="date_of_birth"
          className="form-control"
          value={formData.date_of_birth || ""}
          readOnly
        />
      </div>
      <div className="mt-3">
            <label>Date of Join</label>
            <input
              type="date"
              name="date_of_join"
              className="form-control"
              value={formData.date_of_join || ""}
              readOnly
            />
          </div>

      <div className="mt-3">
      <label>Phone Number</label>
      <div className="d-flex">
        <span className="form-control w-auto px-3">+91</span>
        <input
          type="text"
          name="phone_number"
          className="form-control"
          value={formData.phone_number}
          placeholder="Enter phone number"
          onChange={handleInputChange}
          maxLength="10"
          required
        />
      </div>
      {phoneError && <small className="text-danger">{phoneError}</small>}
    </div>

          <div className="mt-3">
            <label>Emergency Contact</label>
            <input
              type="text"
              name="emergency_contact"
              className="form-control"
              value={formData.emergency_contact}
              placeholder="Enter Emergency Contact"
              onChange={handleInputChange}required
            />
          </div>
          
        <div className="mt-3">
          <label>Address</label>
          <textarea
            name="address"
            className="form-control"
            value={formData.address}
            placeholder="Enter Address"
            onChange={handleInputChange}required
          ></textarea>
        </div>
        <div className="mt-3">
          <label>About</label>
          <textarea
            name="about"
            className="form-control"
            value={formData.about}
            placeholder="Tell us about yourself..."
            onChange={handleInputChange}required
          ></textarea>
        </div>
        <div className="mt-3">
          <label>Education</label>
          {formData.education.map((edu, index) => (
            <div key={index} className="row mb-2">
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Degree"
                  className="form-control"
                  value={edu.degree}
                  onChange={(e) => handleArrayChange('education', index, 'degree', e.target.value)}
                  required/>
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Institute"
                  className="form-control"
                  value={edu.institute}
                  onChange={(e) => handleArrayChange('education', index, 'institute', e.target.value)}
                  required/>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  placeholder="Year"
                  className="form-control"
                  value={edu.year}
                  onChange={(e) => handleArrayChange('education', index, 'year', e.target.value)}
                  required />
              </div>
              <div className="col-md-1">
                <button
                  type="button"
                  className="btn"
                  onClick={() => handleRemoveArrayItem('education', index)}
                >
                  <FaMinus/>
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn"
            onClick={() => handleAddArrayItem('education', { degree: '', institute: '', year: '' })}
          >
            <FaPlus/>
          </button>
        </div>
        <div className="mt-3">
          <label>Social Media Links</label>
          {formData.social_media_links.map((link, index) => (
            <div key={index} className="row mb-2">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Platform"
                  className="form-control"
                  value={link.platform}
                  onChange={(e) => handleArrayChange('social_media_links', index, 'platform', e.target.value)}
                  required/>
              </div>
              <div className="col-md-5">
                <input
                  type="text"
                  placeholder="URL"
                  className="form-control"
                  value={link.url}
                  onChange={(e) => handleArrayChange('social_media_links', index, 'url', e.target.value)}
                  required/>
              </div>
              <div className="col-md-1">
                <button
                  type="button"
                  className="btn"
                  onClick={() => handleRemoveArrayItem('social_media_links', index)}
                >
                  <FaMinus/>
                </button>
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn"
            onClick={() => handleAddArrayItem('social_media_links', { platform: '', url: '' })}
          >
            <FaPlus/>
          </button>
          <ToastNotification ref={toastRef} />
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ProfileModal;
